import { Box, Grid, Typography, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts';

const truncate = (text, max = 28) => {
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max)}...` : text;
};

const ConformidadesPorSetor = ({ data = [] }) => {
  const theme = useTheme();

  const setores = [...new Set(data.map((item) => item?.setor || 'SEM SETOR'))];

  const getQuantidade = (setor, conforme) =>
    data
      .filter(
        (item) =>
          (item?.setor || 'SEM SETOR') === setor && item?.conforme === conforme
      )
      .reduce((acc, item) => acc + Number(item?.quantidade || 0), 0);

  const chartData = setores.map((setor) => ({
    setor,
    conforme: getQuantidade(setor, 'CONFORME'),
    retrabalho: getQuantidade(
      setor,
      'NAO CONFORME COM POSSIBILIDADE DE RETOQUE'
    ),
    refugo: getQuantidade(setor, 'NAO CONFORME PARA SER DESTRUIDO'),
  }));

  if (!chartData.length) return null;

  return (
    <Grid item xs={12} md={6}>
      <Box height="100%" display="flex" flexDirection="column" gap={2}>
        <Typography variant="h5" fontWeight="bold">
          Conformidades
        </Typography>
        <Box mt="auto" width="100%">
          <BarChart
            layout="horizontal"
            height={Math.max(chartData.length * 60, 150)}
            margin={{ left: 220, top: 50, right: 20 }}
            series={[
              {
                label: 'Conforme',
                data: chartData.map((item) => item.conforme),
                stack: 'total',
                color: theme.palette.success.light,
                valueFormatter: (value) => `${value}`,
              },
              {
                label: 'Retrabalho',
                data: chartData.map((item) => item.retrabalho),
                stack: 'total',
                color: theme.palette.warning.light,
                valueFormatter: (value) => `${value}`,
              },
              {
                label: 'Refugo',
                data: chartData.map((item) => item.refugo),
                stack: 'total',
                color: theme.palette.error.light,
                valueFormatter: (value) => `${value}`,
              },
            ]}
            yAxis={[
              {
                scaleType: 'band',
                data: chartData.map((item) => truncate(item.setor)),
                categoryGapRatio: 0.5,
              },
            ]}
            xAxis={[
              {
                label: 'Quantidade',
                min: 0,
                tickMinStep: 1,
              },
            ]}
          />
        </Box>
      </Box>
    </Grid>
  );
};

export default ConformidadesPorSetor;
